<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Promos</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Promos
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4>Promos</h4>
                </div>

                <div class="card-body">
<!--                    <form>-->
<!--                        <div class="row">-->
<!--                            <div class="col-md-4">-->
<!--                                <div class="form-group">-->
<!--                                    <label for="category">By Category</label>-->
<!--                                    <select name="category" id="category" class="form-control form-control-sm"-->
<!--                                            v-model="filters.category">-->
<!--                                        <option :value="null" :selected="filters.category==null">All</option>-->
<!--                                        <option v-for="category in categories" :key="category.id"-->
<!--                                                :value="category.id">-->
<!--                                            {{ category.name }}-->
<!--                                        </option>-->
<!--                                    </select>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            <div class="col-md-4">-->
<!--                                <label>&nbsp;</label>-->
<!--                                <br>-->
<!--                                <button type="submit" @click.prevent="paginatedData"-->
<!--                                        class="btn btn-primary glow mb-1 mb-sm-0">Apply Filter-->
<!--                                </button>-->
<!--                                <button type="reset" @click.prevent="resetFilters"-->
<!--                                        class="btn btn-warning glow mb-1 mb-sm-0">-->
<!--                                    Reset Filter-->
<!--                                </button>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </form>-->
                    <vue-good-table
                        class="dataTable"
                        mode="remote"
                        :isLoading.sync="tableDataLoading"
                        :totalRows="totalRecords"
                        :pagination-options="paginationOptions"
                        :sort-options="sortingOptions"
                        @on-page-change="this.onPageChange"
                        @on-per-page-change="this.onPerPageChange"
                        styleClass="vgt-table"
                        :columns="columns"
                        :rows="allPromos"
                    >

                        <div slot="emptystate" class="loading-container">
                            <img src="/images/Spinner.svg" alt="">
                        </div>
                        <template slot="table-row" slot-scope="props">
                             <span v-if="props.column.field === 'sn'">
                                    {{ serialNo(props) }}
                             </span>
                            <span v-else-if="props.column.field === 'image'">
                               <a :href="'storage/'+props.row.image" target="_blank">
                                   <img :src="'storage/'+props.row.image" :alt="props.row.name +'Image'"
                                        class="img-thumbnail img-fluid"
                                        style="height: auto; max-width:130px; vertical-align: middle; width: 100%;">
                               </a>
                            </span>
                            <span v-else-if="props.column.field === 'apply_automatically'">
                                <template v-if="props.row.apply_automatically">
                                    <span class="badge badge-glow badge-success">Yes</span>
                                </template>
                                <template v-else>
                                    <span class="badge badge-glow badge-danger">No</span>
                                </template>
                            </span>
                            <span v-else-if="props.column.field === 'status'">
                                <template v-if="props.row.status">
                                    <span class="badge badge-success">Active</span>
                                </template>
                                <template v-else>
                                    <span class="badge badge-danger">Inactive</span>
                                </template>
                            </span>
                            <span v-else-if="props.column.field === 'is_new'">
                                <template v-if="props.row.is_new">
                                    <span class="badge badge-glow badge-success">Yes</span>
                                </template>
                                <template v-else>
                                    <span class="badge badge-glow badge-danger">No</span>
                                </template>
                            </span>
                            <table-row-actions v-else-if="props.column.field === 'action'">
                                <Link :href="route('admin.promos.edit', props.row.id)" class="dropdown-item">
                                    <i class="feather icon-edit"></i>
                                    Edit
                                </Link>
                                <a href="#" @click.prevent="showAlert(props.row.id)" class="dropdown-item text-danger">
                                    <i class="feather icon-trash-2"></i>
                                    Delete
                                </a>
                            </table-row-actions>
                        </template>
                    </vue-good-table>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {Link} from '@inertiajs/vue2'
import DeleteAlert from "../../Shared/Mixins/DeleteAlert";
import PaginationMixin from "../../Shared/Mixins/PaginationMixin";

export default {
    metaInfo: {title: 'Promos'},
    props: [
        'promos',
    ],
    layout: Layout,
    name: 'PromoIndex',
    components: {
        Link,
    },
    mixins: [
        DeleteAlert,
        PaginationMixin,
    ],
    data: () => ({

        filters: {
        },
        isLoadingFilter: false,
        allPromos: [],
        totalRecords: 0,
        serverParams: {
            page: 1,
            perPage: 10,
            columnFilters: {},
        },

        paginationOptions: {
            enabled: true,
            mode: 'pages',
            perPage: 10,
            perPageDropdown: [5, 10, 20, 50, 100, 200],
            dropdownAllowAll: false,
        },

        sortingOptions: {
            enabled: false,
        },
        columns: [
            {label: 'S/N', field: 'sn', thClass: 'text-center', tdClass: 'text-center'},
            {label: 'Promo Name', field: 'name', thClass: 'text-center', tdClass: 'text-center'},
            {label: 'Description', field: 'description', thClass: 'text-center', tdClass: 'text-center'},
            {label: 'Code', field: 'code', thClass: 'text-center', tdClass: 'text-center'},
            {label: 'Type', field: 'type', thClass: 'text-center', tdClass: 'text-center'},
            {label: 'Discount Amount', field: 'discount', thClass: 'text-center', tdClass: 'text-center'},
            {label: 'Discount Type', field: 'discount_type', thClass: 'text-center', tdClass: 'text-center'},
            {label: 'Status', field: 'status', thClass: 'text-center', tdClass: 'text-center'},
            {label: 'Apply Automatically ?', field: 'apply_automatically', thClass: 'text-center', tdClass: 'text-center'},
            {label: 'Action', field: 'action', sortable: false},
        ],
        tableDataLoading: false,
    }),
    mounted() {
        this.allPromos = this.promos.data;
        this.totalRecords = this.promos.total;
    },

    methods: {
        updateParams(newProps, paramName = 'serverParams') {
            this[paramName] = Object.assign({}, this[paramName], newProps);
        },
        onPageChange(params, dataFetcher = 'paginatedData') {
            this.updateParams({page: params.currentPage});
            this[dataFetcher]();
        },
        async paginatedData() {
            try {
                let routeName = 'admin.promos.index';

                let response = await axios.get(route(routeName), {
                    params: {
                        page: this.serverParams.page,
                        per_page: this.serverParams.perPage,
                        api: true,
                    },
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                    },
                });

                this.totalRecords = response.data.total;
                this.paginationOptions.perPage = response.data.per_page;
                this.serverParams.perPage = response.data.per_page;
                this.paginationOptions.setCurrentPage = response.data.page;
                this.allPromos = response.data.data
            } catch (e) {
                console.log(e);
            }
        },

        async deletePromo(id) {
            this.$inertia.delete(route('admin.promos.delete', id), {
                preserveScroll: true,
                onSuccess: () => {
                    this.paginatedData();
                }
            })
        },

        async showAlert(promoId) {
            const details = {
                title: "Are you sure you want to delete this promo?",
                text: "You won't be able to revert this!",
            }
            await this.deleteAlert(details.title, details.text) ? await this.deletePromo(promoId) : "";
        },
    }
}
</script>
